<sync-list [ListItems]="itemList"></sync-list>
<div class="load-more" *ngIf="hasMore">
    <sync-button
        type="outlined"
        [isLoading]="isLoading"
        label="Load more..."
        (click)="onLoadMore()"
    ></sync-button>
</div>
<span #bottom></span>